var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center loading-holder"},[(_vm.message)?_c('div',[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._v(" "),_c('pulse-loader',{attrs:{"color":"#EC550E"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }